/**
 * Presentation-only dosage override for Sildenafil Arousal Cream.
 *
 * Existing prescriptions stored the legacy dosage ("1mg/ml"); the corrected
 * strength must be SHOWN to the user without mutating the stored data. Newer
 * prescriptions already store "4% (40mg/ml)", so this is a no-op for them.
 *
 * This is a pure display helper — never use it to write back to a store,
 * service, or the prescription object itself.
 */
export const SILDENAFIL_AROUSAL_CREAM_DOSAGE = '4% (40mg/ml)';

export function formatPrescriptionDosage (medicinename, dosage) {
  if ((medicinename || '').toLowerCase().includes('sildenafil arousal cream')) {
    return SILDENAFIL_AROUSAL_CREAM_DOSAGE;
  }
  return dosage;
}
